import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { brandBibleKeys } from '../../hooks/useBrandBible';

/**
 * TanStack staleness seam, ported from the retired BrandBibleWizardPage
 * (a4326a988): v2 mutations update the legacy flat row server-side via the
 * projection while brandBibleKeys.detail caches it for 5 min with no
 * refetch-on-focus. The wizard's invalidate-on-leave died with its route, so
 * it re-anchors here — on leave (or tenant switch), every consumer of the
 * flat row refetches instead of serving a pre-edit snapshot. The page's
 * once-per-tenant hydration guard keeps the refetch from clobbering the draft.
 */
export function useLegacyBibleInvalidateOnLeave(tenantId: string | null | undefined) {
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!tenantId) return;
    return () => {
      void queryClient.invalidateQueries({ queryKey: brandBibleKeys.detail(tenantId) });
    };
  }, [tenantId, queryClient]);
}
